import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'ehr_systems',
  inputShow: gql`
    query ehrSystems($input: EhrSystemQueryInput) {
      ehrSystems(input: $input) {
        id
        label
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Misc',
    label: 'EHR Systems',
  },
};
